<template>
  <div class="concat-box">
    <banner :title="'联系我们'"></banner>
    <div class="list">
      <div class="l-title">
        <span>
          <b>联系我们</b>
        </span>
      </div>
      <div class="other-kb">
        <div class="wrapp contact">
          <div class="container-fluid">
            <div class="contact-hd">
              <div class="row">
                <div class="col-lg-6" style="box-sizing: border-box">
                  <div class="left">
                    <li>
                      <i class="iconfont icon-dianhua1"></i>
                      <div class="txt">
                        <b>0371-65555168</b>
                        <p>电话</p>
                      </div>
                    </li>
                    <li>
                      <i class="iconfont icon-dianhua1"></i>
                      <div class="txt">
                        <b>0371-68886168</b>
                        <p>电话</p>
                      </div>
                    </li>
                    <li>
                      <i class="iconfont icon-dizhi"></i>
                      <div class="txt">
                        <b>武陟县詹店新区昌平路3号</b>
                        <p>地址</p>
                      </div>
                    </li>
                  </div>
                </div>
                <div class="col-lg-6" style="box-sizing: border-box">
                  <div class="right">
                    <img
                      src="@/assets/images/749da61cb19049b7313a5f0abd7e2f7f.webp"
                      class="ewm"
                      alt="ewm"
                    />
                    <div
                      class="txt"
                      style="
                        display: flex;
                        justify-content: space-around;
                        flex-direction: column;
                      "
                    >
                      <b>微信号</b>
                      <p class="t1">扫描二维码，咨询我们</p>
                      <p class="t2" v-if="false">分享我们:</p>
                      <!-- <br /> -->
                      <div
                        v-if="false"
                        id="share-2"
                        class="share-component social-share"
                      >
                        <a
                          class="social-share-icon icon-qzone iconfont icon-koukoukongjian"
                          href="http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=http%3A%2F%2F168cable.bce163.jzqingfeng.com%2Fcontact.html%23message&amp;title=%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC-%E6%B2%B3%E5%8D%97%E4%B8%80%E5%85%AD%E5%85%AB%E7%BA%BF%E7%BC%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&amp;desc=%E6%B2%B3%E5%8D%97%E4%B8%80%E5%85%AD%E5%85%AB%E7%BA%BF%E7%BC%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E6%98%AF%E6%B2%B3%E5%8D%97%E7%9C%81%E4%B8%93%E9%97%A8%E7%94%9F%E4%BA%A7%E7%94%B5%E7%BA%BF%E7%94%B5%E7%BC%86%E7%9A%84%E4%BC%98%E8%89%AF%E4%BC%81%E4%B8%9A%E4%B9%8B%E4%B8%80%EF%BC%8C%E5%85%AC%E5%8F%B8%E7%94%9F%E4%BA%A7%E4%B8%AD%E5%BF%83%E4%BD%8D%E4%BA%8E%E6%AD%A6%E9%99%9F%E5%8E%BF%E8%A9%B9%E5%BA%97%E5%B7%A5%E4%B8%9A%E5%9B%AD%E5%8C%BA%EF%BC%8C%E7%B4%A7%E9%82%BBS86%E5%8E%9F%E7%84%A6%E9%AB%98%E9%80%9F%E3%80%81G107%E4%BA%AC%E6%B7%B1%E7%BA%BF%EF%BC%8C%E8%B7%9D%E7%A6%BB%E7%9C%81%E4%BC%9A%E9%83%91%E5%B7%9E%E4%BB%8530%E5%85%AC%E9%87%8C%EF%BC%8C%E4%BA%A4%E9%80%9A%E4%BE%BF%E5%88%A9%EF%BC%8C%E6%8C%89%E7%85%A7%E8%8A%B1%E5%9B%AD%E5%BC%8F%E6%A0%87%E5%87%86%E5%8C%96%E5%8E%82%E6%88%BF%E5%BB%BA%E8%AE%BE%EF%BC%8C%E7%8E%AF%E5%A2%83%E4%BC%98%E7%BE%8E%EF%BC%8C%E6%8B%A5%E6%9C%89%E5%85%88%E8%BF%9B%E7%94%9F%E4%BA%A7%E8%AE%BE%E5%A4%87%E5%92%8C%E6%A3%80%E6%B5%8B%E8%AE%BE%E5%A4%87%E3%80%82&amp;summary=%E6%B2%B3%E5%8D%97%E4%B8%80%E5%85%AD%E5%85%AB%E7%BA%BF%E7%BC%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E6%98%AF%E6%B2%B3%E5%8D%97%E7%9C%81%E4%B8%93%E9%97%A8%E7%94%9F%E4%BA%A7%E7%94%B5%E7%BA%BF%E7%94%B5%E7%BC%86%E7%9A%84%E4%BC%98%E8%89%AF%E4%BC%81%E4%B8%9A%E4%B9%8B%E4%B8%80%EF%BC%8C%E5%85%AC%E5%8F%B8%E7%94%9F%E4%BA%A7%E4%B8%AD%E5%BF%83%E4%BD%8D%E4%BA%8E%E6%AD%A6%E9%99%9F%E5%8E%BF%E8%A9%B9%E5%BA%97%E5%B7%A5%E4%B8%9A%E5%9B%AD%E5%8C%BA%EF%BC%8C%E7%B4%A7%E9%82%BBS86%E5%8E%9F%E7%84%A6%E9%AB%98%E9%80%9F%E3%80%81G107%E4%BA%AC%E6%B7%B1%E7%BA%BF%EF%BC%8C%E8%B7%9D%E7%A6%BB%E7%9C%81%E4%BC%9A%E9%83%91%E5%B7%9E%E4%BB%8530%E5%85%AC%E9%87%8C%EF%BC%8C%E4%BA%A4%E9%80%9A%E4%BE%BF%E5%88%A9%EF%BC%8C%E6%8C%89%E7%85%A7%E8%8A%B1%E5%9B%AD%E5%BC%8F%E6%A0%87%E5%87%86%E5%8C%96%E5%8E%82%E6%88%BF%E5%BB%BA%E8%AE%BE%EF%BC%8C%E7%8E%AF%E5%A2%83%E4%BC%98%E7%BE%8E%EF%BC%8C%E6%8B%A5%E6%9C%89%E5%85%88%E8%BF%9B%E7%94%9F%E4%BA%A7%E8%AE%BE%E5%A4%87%E5%92%8C%E6%A3%80%E6%B5%8B%E8%AE%BE%E5%A4%87%E3%80%82&amp;site=%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC-%E6%B2%B3%E5%8D%97%E4%B8%80%E5%85%AD%E5%85%AB%E7%BA%BF%E7%BC%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&amp;pics=http%3A%2F%2F168cable.bce163.jzqingfeng.com%2Fuploads%2F20211206%2Ff17a00feb670a445666f51359f89a5ed.webp"
                          target="_blank"
                        ></a
                        ><a
                          class="social-share-icon icon-qq icon-koukou iconfont"
                          href="http://connect.qq.com/widget/shareqq/index.html?url=http%3A%2F%2F168cable.bce163.jzqingfeng.com%2Fcontact.html%23message&amp;title=%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC-%E6%B2%B3%E5%8D%97%E4%B8%80%E5%85%AD%E5%85%AB%E7%BA%BF%E7%BC%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&amp;source=%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC-%E6%B2%B3%E5%8D%97%E4%B8%80%E5%85%AD%E5%85%AB%E7%BA%BF%E7%BC%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&amp;desc=%E6%B2%B3%E5%8D%97%E4%B8%80%E5%85%AD%E5%85%AB%E7%BA%BF%E7%BC%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E6%98%AF%E6%B2%B3%E5%8D%97%E7%9C%81%E4%B8%93%E9%97%A8%E7%94%9F%E4%BA%A7%E7%94%B5%E7%BA%BF%E7%94%B5%E7%BC%86%E7%9A%84%E4%BC%98%E8%89%AF%E4%BC%81%E4%B8%9A%E4%B9%8B%E4%B8%80%EF%BC%8C%E5%85%AC%E5%8F%B8%E7%94%9F%E4%BA%A7%E4%B8%AD%E5%BF%83%E4%BD%8D%E4%BA%8E%E6%AD%A6%E9%99%9F%E5%8E%BF%E8%A9%B9%E5%BA%97%E5%B7%A5%E4%B8%9A%E5%9B%AD%E5%8C%BA%EF%BC%8C%E7%B4%A7%E9%82%BBS86%E5%8E%9F%E7%84%A6%E9%AB%98%E9%80%9F%E3%80%81G107%E4%BA%AC%E6%B7%B1%E7%BA%BF%EF%BC%8C%E8%B7%9D%E7%A6%BB%E7%9C%81%E4%BC%9A%E9%83%91%E5%B7%9E%E4%BB%8530%E5%85%AC%E9%87%8C%EF%BC%8C%E4%BA%A4%E9%80%9A%E4%BE%BF%E5%88%A9%EF%BC%8C%E6%8C%89%E7%85%A7%E8%8A%B1%E5%9B%AD%E5%BC%8F%E6%A0%87%E5%87%86%E5%8C%96%E5%8E%82%E6%88%BF%E5%BB%BA%E8%AE%BE%EF%BC%8C%E7%8E%AF%E5%A2%83%E4%BC%98%E7%BE%8E%EF%BC%8C%E6%8B%A5%E6%9C%89%E5%85%88%E8%BF%9B%E7%94%9F%E4%BA%A7%E8%AE%BE%E5%A4%87%E5%92%8C%E6%A3%80%E6%B5%8B%E8%AE%BE%E5%A4%87%E3%80%82&amp;pics=http%3A%2F%2F168cable.bce163.jzqingfeng.com%2Fuploads%2F20211206%2Ff17a00feb670a445666f51359f89a5ed.webp"
                          target="_blank"
                        ></a
                        ><a
                          class="social-share-icon icon-weibo icon-shejiaotubiao-06 iconfont"
                          href="https://service.weibo.com/share/share.php?url=http%3A%2F%2F168cable.bce163.jzqingfeng.com%2Fcontact.html%23message&amp;title=%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC-%E6%B2%B3%E5%8D%97%E4%B8%80%E5%85%AD%E5%85%AB%E7%BA%BF%E7%BC%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&amp;pic=http%3A%2F%2F168cable.bce163.jzqingfeng.com%2Fuploads%2F20211206%2Ff17a00feb670a445666f51359f89a5ed.jpg&amp;appkey="
                          target="_blank"
                        ></a
                        ><a
                          class="social-share-icon icon-wechat icon-weixin iconfont"
                          href="javascript:;"
                          tabindex="-1"
                          ><div class="wechat-qrcode">
                            <h4>微信扫一扫：分享</h4>
                            <div class="qrcode">
                              <img
                                src="data:image/png;base64,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"
                              />
                            </div>
                            <div class="help">
                              <p>微信里点“发现”，扫一下</p>
                              <p>二维码便可将本文分享至朋友圈。</p>
                            </div>
                          </div></a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-md">
              <tianmap></tianmap>
            </div>
            <contact></contact>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "../components/banner.vue";
import tianmap from "../components/tianmap.vue";
import contact from "../components/contact.vue";
export default {
  components: {
    banner,
    tianmap,
    contact,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.concat-box {
  width: 100%;
  height: fit-content;
}
.l-title b:after {
  content: "";
  width: 100px;
  height: 3px;
  background: @primaryColor;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 0;
}
.list .warp p {
  text-align: left;
}
.bd span {
  padding-right: 5px;
}

.wechat-qrcode {
  display: none;
  border: 1px solid #eee;
  position: absolute;
  z-index: 9;
  top: -205px;
  left: -84px;
  width: 200px;
  height: 230px;
  color: #666;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
  box-shadow: 0 2px 10px #aaa;
  transition: all 200ms;
  -webkit-tansition: all 350ms;
  -moz-transition: all 350ms;

  h4 {
    font-weight: normal;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    background-color: #f3f3f3;
    margin: 0;
    padding: 0;
    color: #777;
  }
  .qrcode {
    width: 105px;
    margin: 10px auto;
  }
}

.social-share .social-share-icon {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 32px;
  font-size: 20px;
  border-radius: 50%;
  line-height: 32px;
  border: 1px solid #666;
  color: #666;
  text-align: center;
  vertical-align: middle;
  transition: background 0.6s ease-out 0s;
}
.social-share .social-share-icon:hover {
  background: #666;
  color: #fff;
}
.social-share a {
  position: relative;
  text-decoration: none;
  margin: 4px;
  display: inline-block;
  outline: none;
}
.social-share .icon-wechat:hover {
  background: #7bc549;
}
.social-share .icon-wechat {
  position: relative;
  color: #7bc549;
  border-color: #7bc549;
}

.social-share .icon-qzone {
  color: #fdbe3d;
  border-color: #fdbe3d;
}
.social-share .icon-weibo:hover {
  background: #ff763b;
}

.social-share .icon-weibo {
  color: #ff763b;
  border-color: #ff763b;
}
.social-share .icon-weibo:hover {
  background: #ff763b;
}
.social-share .icon-qq {
  color: #56b6e7;
  border-color: #56b6e7;
}
.social-share .icon-qq:hover {
  background: #56b6e7;
}
.social-share .icon-qzone:hover {
  background: #fdbe3d;
}
</style>
